// extracted by mini-css-extract-plugin
export default {"site-header-small":"820px","automated-row-grouping-medium":"740px"};